import React from "react";
import { Clock, ThumbsUp, Users } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ThePatchDoctorsPromise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const features = [{
    title: "RELIABILITY",
    icon: Clock,
    description: "At Elyon Maintenance Inc., reliability is our foundation. Whether it's scheduled janitorial work or seasonal landscaping, our professional team ensures your facility remains in peak condition without fail.",
    highlight: false
  }, {
    title: "CONVENIENCE",
    icon: ThumbsUp,
    description: "Simplify your property management with our one-stop-shop approach. From interior painting to high-pressure power washing, we provide all-in-one home services that save you time and logistical headaches.",
    highlight: true
  }, {
    title: "CRAFTSMANSHIP",
    icon: Users,
    description: "We pride ourselves on top-tier craftsmanship and professional property care. Our technicians bring meticulous attention to every brushstroke and pressure-wash, ensuring your investment looks its absolute best.",
    highlight: false
  }];
  return;
}